import { useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Button } from '../input';
import { moneyFormatter } from '../../shared';
import { colors } from '../../constants';
import { useGlobal } from '../../state';

const transactionTypeLabels = {
  user_refill: 'User added credits',
  spend: 'Credits spent while scraping',
  auto_refill: 'Auto reloaded credits',
  subscription: 'Support subscription',
};

export const TransactionsTable = ({ transactions }) => {
  const { host, apiKey } = useGlobal();
  const [downloadingId, setDownloadingId] = useState(null);

  const cellStyle = {
    padding: '4px 8px',
  };

  const linkStyle = {
    color: colors.linkBlue,
    textDecoration: 'underline',
    background: 'none',
    border: 0,
    padding: 0,
    cursor: 'pointer',
    font: 'inherit',
  };

  const getInvoiceUrl = (transactionId) => `${host}/api/credits/transactions/${transactionId}/invoice`;

  const downloadInvoice = async (transaction) => {
    if (!transaction?.id || !host || downloadingId) {
      return;
    }

    setDownloadingId(transaction.id);

    try {
      const resp = await fetch(getInvoiceUrl(transaction.id), {
        headers: apiKey
          ? {
              Authorization: `Bearer ${apiKey}`,
            }
          : {},
      });

      if (!resp.ok) {
        throw new Error(`Failed to download invoice (${resp.status})`);
      }

      const blob = await resp.blob();
      const href = URL.createObjectURL(blob);
      const contentDisposition = resp.headers.get('content-disposition') || '';
      const filename = contentDisposition.match(/filename="([^"]+)"/)?.[1] || `fetchfox-invoice-${transaction.id}.pdf`;

      const a = document.createElement('a');
      a.href = href;
      a.download = filename;

      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(href);
    } catch (e) {
      console.error('Failed to download invoice', e);
      alert('Unable to download invoice PDF right now.');
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <table>
      <thead>
        <tr>
          <th style={{ ...cellStyle }}>Type</th>
          <th style={{ ...cellStyle }}>Amount</th>
          <th style={{ ...cellStyle }}>Timestamp</th>
          <th style={{ ...cellStyle }}>Invoice</th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((it) => (
          <tr key={it.id}>
            <td style={{ ...cellStyle }}>{transactionTypeLabels[it.type] ?? 'Transaction'}</td>
            <td style={{ ...cellStyle, textAlign: 'right' }}>{moneyFormatter.format(it.amount)}</td>
            <td style={{ ...cellStyle, textAlign: 'right' }}>
              {formatDistanceToNow(it.createdAt, { addSuffix: true })}
            </td>
            <td style={{ ...cellStyle, textAlign: 'center' }}>
              {it.id ? (
                <a
                  target="_blank"
                  href={getInvoiceUrl(it.id)}
                  style={{
                    ...linkStyle,
                    opacity: downloadingId === it.id ? 0.6 : 1,
                    pointerEvents: downloadingId && downloadingId !== it.id ? 'none' : 'auto',
                  }}
                >
                  Get Invoice
                </a>
              ) : (
                <span style={{ color: '#999' }}>-</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
